const greetings = `👋 Greetings! I am Skill Builder Assistant, your virtual assistant for this lab. I'm here to provide answers to your questions and offer helpful prompts along the way.`;
const initQuestionsIntro = `Ask me anything about this learning content or choose a sample question below to start a conversation.`;
const defaultInitQuestionOption = [`Lab overview and objectives`];
const thumbsUpTooltipTextOnHover = 'Helpful';
const thumbsDownTooltipTextOnHover = 'Not helpful';
const initialMessages = [
    { sender: 'bot', text: greetings },
];
// This used to indicate the feedback versions, in future, we should make this number dynamic and changed based on which page we are on.
let feedbackVersionNumber = 0;
/**
 * Per previous discussion with team, we could have multiple template with feedback response versions, so make it an array here
 */
const negativeFeedbackTemplate = [
    {
        text: `It seems my response didn't quite meet your expectations. Could you please share what you found unsatisfactory? Your feedback will help me improve and provide better assistance in the future.`,
        options: [
            'Inaccurate',
            'Irrelevant',
            'Too brief',
            'Too long',
            'Confusing',
            'Incomplete',
            'Harmful or offensive'
        ],
        response: `Apologies for any confusion caused. I'm committed to continuous improvement and learning. Your input is invaluable in helping me enhance my capabilities. Thanks for taking the time to assist me in refining my skills!`
    }
];
const positiveFeedbackTemplate = [
    {
        text: `Thank you for the positive rating! We're glad to have been helpful.`
    }
];
const WIDGET_ID = "LearnerAssistantWidget";
const eventHorizonCookiePreferencesModalId = "awsccc-cs-content";
/**
 * This is a map used to dynamic determine the API endpoints.
 * It's expected to be modified based on the needs.
 * It will default to wss://api.ws.jiongran.assistant.skillbuilder.training.aws.dev/ for now
 * Once we have beta api endpoint available, we can change EH team's endpoint here
 * Please feel free to edit this map once we have a real beta/gamma/prod endpoint
 */
const ENDPOINT_MAP = {
    'test.alpha.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.alpha.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.alpha.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'test.beta.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.beta.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.beta.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'test.gamma.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.gamma.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.gamma.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'beta.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.beta.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.beta.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'gamma.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.gamma.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.gamma.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'sensaidev.test.events.training.aws.a2z.com': {
        websocketProxyEndpoint: 'wss://ws.proxy.sensaidev.test.events.training.aws.a2z.com/',
        restProxyEndpoint: 'https://proxy.sensaidev.test.events.training.aws.a2z.com/assistant/'
    },
    'xinrum.aka.corp.amazon.com': {
        websocketProxyEndpoint: 'wss://ws.proxy.xinrum.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.xinrum.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'stihahi.aka.corp.amazon.com': {
        websocketProxyEndpoint: 'wss://ws.proxy.stihahi.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.stihahi.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'qlinz.aka.corp.amazon.com': {
        websocketProxyEndpoint: 'wss://ws.proxy.qlinz.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.qlinz.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'test.stihahi.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.stihahi.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.stihahi.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'test.chejenni.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.chejenni.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.chejenni.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'test.gojie.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.gojie.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.gojie.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'test.jiongran.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.jiongran.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.jiongran.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'test.yaopa.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.yaopa.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.yaopa.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'test.xinrum.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.xinrum.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.xinrum.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'test.qlinz.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.qlinz.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.qlinz.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'test.satkart.assistant.skillbuilder.training.aws.dev': {
        websocketProxyEndpoint: 'wss://ws.proxy.satkart.assistant.skillbuilder.training.aws.dev/',
        restProxyEndpoint: 'https://proxy.satkart.assistant.skillbuilder.training.aws.dev/assistant/'
    },
    'global.gamma.eventhorizon.events.training.aws.a2z.com': {
        websocketProxyEndpoint: 'wss://ws.proxy.global.gamma.eventhorizon.events.training.aws.a2z.com/',
        restProxyEndpoint: 'https://proxy.global.gamma.eventhorizon.events.training.aws.a2z.com/assistant/'
    }
};
/**
  * Please change this map if backend requires a specific format, but I didn't find any now.
  */
const FEEDBACK_REASON_CODE = {
    'Inaccurate': 'Inaccurate',
    'Irrelevant': 'Irrelevant',
    'Too brief': 'Too_Brief',
    'Too long': 'Too_Long',
    'Confusing': 'Confusing',
    'Incomplete': 'Incomplete',
    'Harmful or offensive': 'Harmful_Offensive'
};

export { ENDPOINT_MAP, FEEDBACK_REASON_CODE, WIDGET_ID, defaultInitQuestionOption, eventHorizonCookiePreferencesModalId, feedbackVersionNumber, greetings, initQuestionsIntro, initialMessages, negativeFeedbackTemplate, positiveFeedbackTemplate, thumbsDownTooltipTextOnHover, thumbsUpTooltipTextOnHover };
